module.exports = __webpack_public_path__ + "static/media/plan-summary.e08a28d8.svg";